import { render, staticRenderFns } from "./NewTransferConclusion.vue?vue&type=template&id=7506b69a&scoped=true&"
import script from "./NewTransferConclusion.vue?vue&type=script&lang=ts&"
export * from "./NewTransferConclusion.vue?vue&type=script&lang=ts&"
import style0 from "./NewTransferConclusion.vue?vue&type=style&index=0&id=7506b69a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506b69a",
  null
  
)

export default component.exports